import { DropdownMenu } from "@zapier/product-nav";
import { useAtomValue, useSetAtom } from "jotai";
import {
  isKeyboardShortcutsModalOpenAtom,
  startTourSetter,
  isTourOrExplanationActiveAtom,
  hasTourableNodesAtom,
  emitUserInteractionEventSetter,
} from "@zapier/canvas-state";

import { useEmitUserInteractionEvents } from "../../hooks/useEmitUserInteractionEvents";
import { useCopilotChat } from "@zapier/ai-toolkit/client";

const TAKE_CANVAS_TOUR = "Tour my Canvas";

const HelpMenu = () => {
  const { emitEventOnHelpClick } = useEmitUserInteractionEvents();
  const setIsKeyboardShortcutsModalOpen = useSetAtom(
    isKeyboardShortcutsModalOpenAtom,
  );
  const emitUserInteractionEvent = useSetAtom(emitUserInteractionEventSetter);
  const startTour = useSetAtom(startTourSetter);
  const isTourActive = useAtomValue(isTourOrExplanationActiveAtom);
  const hasTourableNodes = useAtomValue(hasTourableNodesAtom);

  const copilot = useCopilotChat();

  const helpMenuItems = [
    {
      title: TAKE_CANVAS_TOUR,
      action: async () => {
        if (!isTourActive && hasTourableNodes) {
          try {
            await startTour({
              copilot,
            });

            await emitUserInteractionEvent({
              eventAction: "click",
              interactionGoal: "Canvas tour started",
              rawText: TAKE_CANVAS_TOUR,
            });
          } catch (error) {
            console.error("Failed to start tour from help menu:", error);
          }
        }
      },
      id: "take-canvas-tour",
      isDisabled: isTourActive || !hasTourableNodes,
    },
    {
      title: "Help center",
      action: () => {
        window.open("https://canvas.zapier.app", "_blank");
      },
      id: "help-center",
    },
    {
      title: "Contact us",
      action: () => {
        window.open(
          "https://npsup.zapier.app/contact-us?product=Canvas",
          "_blank",
        );
      },
      id: "contact-us",
    },
    {
      title: "Keyboard shortcuts",
      action: () => {
        setIsKeyboardShortcutsModalOpen(true);
      },
      id: "keyboard-shortcuts",
    },
  ];

  const actions = {
    ...helpMenuItems.reduce(
      (obj, item) => ({ ...obj, [item.id]: item.action }),
      {},
    ),
  };
  const handleAction = (key: React.Key) => {
    const action = actions[key as keyof typeof actions];
    if (action) {
      if (typeof action === "function") {
        (action as typeof Function)();
      }
    }
  };

  return (
    <DropdownMenu
      iconBefore="navHelp"
      iconAfter="arrowSmallDown"
      label="Help"
      onAction={handleAction}
      placement="bottom right"
      onClose={emitEventOnHelpClick}
    >
      {helpMenuItems.map((item) => (
        <DropdownMenu.Item
          key={item.title}
          id={item.id}
          isDisabled={item.isDisabled}
        >
          {item.title}
        </DropdownMenu.Item>
      ))}
    </DropdownMenu>
  );
};
export default HelpMenu;
